"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.change_act = change_act;
exports.change_goods = change_goods;
exports.del_act = del_act;
exports.del_goods = del_goods;
exports.export_order = export_order;
exports.getAll = getAll;
exports.get_act = get_act;
exports.get_goods = get_goods;
exports.get_order = get_order;
exports.get_pid = get_pid;
exports.get_select = get_select;
exports.query_act = query_act;
exports.query_goods = query_goods;
exports.save_pid = save_pid;
exports.searchGoods = searchGoods;
var _request = _interopRequireDefault(require("@/utils/request"));
function save_pid(data) {
  return (0, _request.default)({
    url: "/portal/system/giftsubsidy/pid/save",
    method: "post",
    data: data
  });
}
function get_pid(params) {
  return (0, _request.default)({
    url: "/portal/system/giftsubsidy/pid/query",
    method: "get",
    params: params
  });
}
function get_act(params) {
  return (0, _request.default)({
    url: "/portal/system/giftsubsidy/activity/query",
    method: "get",
    params: params
  });
}
function del_act(data) {
  return (0, _request.default)({
    url: "/portal/system/giftsubsidy/activity/delete",
    method: "post",
    data: data
  });
}
function change_act(data) {
  return (0, _request.default)({
    url: "/portal/system/giftsubsidy/activity/save",
    method: "post",
    data: data
  });
}
function getAll(params) {
  return (0, _request.default)({
    url: "/portal/system/giftsubsidy/acct/query",
    method: "get",
    params: params
  });
}
function change_goods(data) {
  return (0, _request.default)({
    url: "/portal/system/giftsubsidy/goods/save",
    method: "post",
    data: data
  });
}
function get_goods(params) {
  return (0, _request.default)({
    url: "/portal/system/giftsubsidy/goods/query",
    method: "get",
    params: params
  });
}
function get_order(params) {
  return (0, _request.default)({
    url: "/portal/system/giftsubsidy/order/query",
    method: "get",
    params: params
  });
}
function get_select(params) {
  return (0, _request.default)({
    url: "/portal/system/giftsubsidy/activity/select/query",
    method: "get",
    params: params
  });
}
function searchGoods(data) {
  return (0, _request.default)({
    url: "/portal/system/giftsubsidy/goods/search",
    method: "post",
    data: data
  });
}
function query_goods(params) {
  return (0, _request.default)({
    url: "/portal/system/giftsubsidy/goods/detail/query",
    method: "get",
    params: params
  });
}
function del_goods(data) {
  return (0, _request.default)({
    url: "/portal/system/giftsubsidy/goods/delete",
    method: "post",
    data: data
  });
}
function query_act(params) {
  return (0, _request.default)({
    url: "/portal/system/giftsubsidy/activity/detail/query",
    method: "get",
    params: params
  });
}
function export_order(data) {
  return (0, _request.default)({
    url: "/portal/system/file/export",
    method: "post",
    data: data
  });
}